import catalog from './resources.json';

const known = new Set(catalog);
export const isRealtimeResource = resource => known.has(resource);
export function normalizeResources(resources) {
  if (!Array.isArray(resources) || resources.some(r => !known.has(r))) throw new Error('UNKNOWN_REALTIME_RESOURCE');
  return [...new Set(resources)].sort();
}

// Resolve relative Portal API paths explicitly; never classify external URLs by suffix.
export function resourceForUrl(value, portalBaseUrl) {
  try {
    const base = new URL(portalBaseUrl);
    if (!['http:', 'https:'].includes(base.protocol) || base.search || base.hash) return null;
    const root = base.pathname.replace(/\/+$/, '');
    const raw = String(value);
    const absolute = /^[a-z][a-z0-9+.-]*:|^\/\//i.test(raw);
    const url = absolute ? new URL(raw, base) : new URL(`${base.origin}${root}/${raw.replace(/^\/+/, '')}`);
    if (url.origin !== base.origin || url.username || url.password || url.hash || !url.pathname.startsWith(`${root}/`)) return null;
    const route = url.pathname.slice(root.length + 1).replace(/\/+$/, '');
    const resource = `portal:${route}`;
    return known.has(resource) ? resource : null;
  } catch { return null; }
}

// Optional tags for future query integration. Does not modify portalApi or dispatch.
export const realtimeResourceTag = resource => {
  if (!known.has(resource)) throw new Error('UNKNOWN_REALTIME_RESOURCE');
  return { type: 'RealtimeResource', id: resource };
};
